import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";

const ArrowCircleUp = (props: any) => {
  return <ArrowCircleUpIcon {...props} />;
};

export default ArrowCircleUp;
